import React from "react";

const AdBanner = (props: { startAt?: Date; endAt?: Date }) => {
  if (props.startAt != null && new Date() < props.startAt) {
    return null;
  }

  if (props.endAt != null && new Date() > props.endAt) {
    return null;
  }

  return (
    <a
      href="https://sites.google.com/a/esc13.net/tekscon/home"
      target="tekscon"
    >
      <img
        src="https://examspark-app-files-master.s3.amazonaws.com/public/tcmpc/tx-tekscon-2025.png"
        alt="TEKSCon, San Antonio, TX, June 5-6, 2025"
        width="100%"
      />
    </a>
  );
};

export default AdBanner;
